<label class="form-label">{{ fieldLabel() }}</label>
@if (supportsModes()) {
  <div
    class="filter-input-trigger select-wrapper custom-filter-wrapper"
    #inputTrigger
    (click)="toggleDropdown()"
    [class.active]="isDropdownOpen()"
    [class.opened]="isDropdownOpen()"
    [class.has-value]="displayValue()">
    <input
      type="text"
      class="select-input form-control filter-header-input search-filter slick-filter slick-filter-custom"
      readonly
      [value]="displayTriggerValue()"
      [placeholder]="translate('LanguageService::ZnSelectPlaceholder')"
    />
    <span class="slick-filter-icons"></span>
  </div>

  <ng-template #dropdownTemplate>
    <div class="custom-filter-dropdown form-control-container">
      <div class="filter-mode-selector">
        @for (mode of modeOptions(); track mode.id) {
          <div>
            <label class="filter-radio-label form-check-label" [class.selected]="currentMode() === mode.id">
              <input
                type="radio"
                name="filter-mode-{{ field.key }}"
                [value]="mode.id"
                [checked]="currentMode() === mode.id"
                class="filter-radio form-check-input"
                (change)="setMode(mode.id)"
              />
              <span class="mode-label">{{ translate(mode.labelKey) }}</span>
            </label>

            @if (currentMode() === mode.id) {
              <div class="filter-inputs">
                @switch (mode.id) {
                  @case ('equal') {
                    @if (equalLabelKey()) {
                      <label class="input-label" [for]="equalInputId">{{ translate(equalLabelKey()) }}</label>
                    }
                    <input
                      [id]="equalInputId"
                      [type]="getInputType()"
                      class="form-control"
                      [ngModel]="equalValue()"
                      [placeholder]="translate('LanguageService::EnterNumber')"
                      (ngModelChange)="onEqualValueChange($event)"
                    />
                  }
                  @case ('range') {
                    <div class="between-inputs">
                      <div>
                        @if (showRangeLabels()) {
                          <label class="input-label">{{ translate('LanguageService::FromRange') }}</label>
                        }
                        <input
                          [type]="getInputType()"
                          class="form-control"
                          [placeholder]="translate('LanguageService::EnterNumber')"
                          [ngModel]="fromValue()"
                          (ngModelChange)="onFromValueChange($event)"
                        />
                      </div>
                      <div>
                        @if (showRangeLabels()) {
                          <label class="input-label">{{ translate('LanguageService::ToRange') }}</label>
                        }
                        <input
                          [type]="getInputType()"
                          class="form-control"
                          [placeholder]="translate('LanguageService::EnterNumber')"
                          [ngModel]="toValue()"
                          (ngModelChange)="onToValueChange($event)"
                        />
                      </div>
                    </div>
                  }
                  @case ('periods') {
                    <div>
                      @for (period of periodOptions; track period.value) {
                        <label class="period-radio-label" [class.selected]="periodValue() === period.value">
                          <input
                            type="radio"
                            name="period-{{ field.key }}"
                            [value]="period.value"
                            [checked]="periodValue() === period.value"
                            class="filter-radio form-check-input"
                            (change)="onPeriodChange(period.value)"
                          />
                          {{ translate(period.labelKey) }}
                        </label>
                      }
                    </div>
                  }
                }
              </div>
            }
          </div>
        }
      </div>

      <div class="dropdown-actions">
        <button type="button" class="btn btn-primary btn-sm apply-button" (click)="onApply()">
          {{ translate('LanguageService::Apply') }}
        </button>
      </div>
    </div>
  </ng-template>
} @else {
  @switch (fieldType()) {
    @case ('text') {
      <input
        type="text"
        class="form-control"
        [placeholder]="translate('LanguageService::Contains')"
        [ngModel]="equalValue()"
        (ngModelChange)="onEqualValueChange($event)"
      />
    }

    @case ('foreignKey') {
      @if (field?.fieldOptions?.prefilter?.multiple) {
        <zn-multi-select
          [optionsLoader]="prefilterOptionsLoader()"
          [deferSelection]="false"
          [showSearch]="true"
          [emptyDisplayValue]="'LanguageService::ZnAll'"
          [placeholder]="prefilterPlaceholderKey()"
          [showPlaceholder]="prefilterShowPlaceholder()"
          [ngModel]="selectedOptions()"
          (ngModelChange)="onOptionsChange($event)"
        ></zn-multi-select>
      } @else {
        <zn-single-select
          [optionsLoader]="prefilterOptionsLoader()"
          [showSearch]="true"
          [placeholder]="prefilterPlaceholderKey()"
          [showPlaceholder]="prefilterShowPlaceholder()"
          [ngModel]="selectedOptions()"
          (ngModelChange)="onOptionsChange($event)"
        ></zn-single-select>
      }
    }

    @case ('dropdown') {
      @if (field?.fieldOptions?.prefilter?.multiple) {
        <zn-multi-select
          [options]="dropdownOptions()"
          [deferSelection]="false"
          [showSearch]="true"
          [emptyDisplayValue]="prefilterEmptyDisplayValueKey()"
          [placeholder]="prefilterPlaceholderKey()"
          [showPlaceholder]="prefilterShowPlaceholder()"
          [ngModel]="selectedOptions()"
          (ngModelChange)="onOptionsChange($event)"
        ></zn-multi-select>
      } @else {
        <zn-single-select
          [options]="dropdownOptions()"
          [showSearch]="true"
          [placeholder]="prefilterPlaceholderKey()"
          [showPlaceholder]="prefilterShowPlaceholder()"
          [ngModel]="selectedOptions()"
          (ngModelChange)="onOptionsChange($event)"
        ></zn-single-select>
      }
    }

    @case ('checkbox') {
      <div class="checkbox-options">
        <label class="checkbox-option" [class.selected]="checkboxValue() === true">
          <input
            type="radio"
            name="checkbox-{{ field.key }}"
            [value]="true"
            [checked]="checkboxValue() === true"
            (change)="onCheckboxChange(true)"
          />
          {{ translate('LanguageService::True') }}
        </label>
        <label class="checkbox-option" [class.selected]="checkboxValue() === false">
          <input
            type="radio"
            name="checkbox-{{ field.key }}"
            [value]="false"
            [checked]="checkboxValue() === false"
            (change)="onCheckboxChange(false)"
          />
          {{ translate('LanguageService::False') }}
        </label>
        <label class="checkbox-option" [class.selected]="checkboxValue() === null">
          <input
            type="radio"
            name="checkbox-{{ field.key }}"
            [value]="null"
            [checked]="checkboxValue() === null"
            (change)="onCheckboxChange(null)"
          />
          {{ translate('LanguageService::ZnAll') }}
        </label>
      </div>
    }
  }
}
